export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-calendar-ba52d807c2c08c99d0ede569ab9388cf.svg";